import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useEmailSignatureTable } from "hooks/useEmailSignatureTable";
import EmailSignatureService from "services/EmailSignatures";
import { Button } from "@/components/ui/button";
import Authorized from "components/Authorized";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { getNextQueryParams } from "components/helpers";
import useAuthorized from "hooks/useAuthorized";
import ACL_RELATIONSHIPS from "acl-relationships";
import { invalidateEmailSignatureTableQuery } from "hooks/useEmailSignatureTable";

export const EMAIL_SIGNATURE_TABLE_CONSTANTS = {
  tableName: "email_signatures",
  queryKey: "email_signature",
  className: "EmailSignature",
  header: "Email Signatures",
  headerIcon: "mail outline",
};

const EmailSignatureTableV3 = () => {
  const navigate = useNavigate();
  const enableTags = useAuthorized(
    [
      ACL_RELATIONSHIPS.emailSignaturesTags.create,
      ACL_RELATIONSHIPS.emailSignaturesTags.read,
      ACL_RELATIONSHIPS.emailSignaturesTags.delete,
    ],
    { partialMatch: true }
  );
  const { filters, columns } = useEmailSignatureTable({
    className: EMAIL_SIGNATURE_TABLE_CONSTANTS.className,
    tableName: EMAIL_SIGNATURE_TABLE_CONSTANTS.tableName,
  });

  const fetchData = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await EmailSignatureService.getEmailSignatures(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching email signatures:", error);
        throw error;
      }
    },
    [columns]
  );

  const createButton = (
    <Authorized permissions={[ACL_RELATIONSHIPS.emailSignatures.create]}>
      <Button
        size="sm"
        className="item-adder"
        onClick={() => navigate("/settings/email_signatures/new")}
      >
        New Signature Template
      </Button>
    </Authorized>
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      tagsDropdownParams={{ visible: enableTags }}
      queryKey={EMAIL_SIGNATURE_TABLE_CONSTANTS.queryKey}
      className={EMAIL_SIGNATURE_TABLE_CONSTANTS.className}
      tableName={EMAIL_SIGNATURE_TABLE_CONSTANTS.tableName}
      headerIcon={EMAIL_SIGNATURE_TABLE_CONSTANTS.headerIcon}
      header={EMAIL_SIGNATURE_TABLE_CONSTANTS.header}
      enableSearch
      enableSettings
      fetchData={fetchData}
      createButton={createButton}
      invalidateData={invalidateEmailSignatureTableQuery}
    />
  );
};

export default EmailSignatureTableV3;
